import { verdictMeta } from '@/lib/verdict';
import type { VerdictKey } from '@/types/content';

interface VerdictBadgeProps {
  verdict: VerdictKey;
  size?: 'sm' | 'md';
  showIcon?: boolean;
}

export default function VerdictBadge({ verdict, size = 'sm', showIcon = true }: VerdictBadgeProps) {
  const meta = verdictMeta[verdict];
  const sizeClass = size === 'sm' ? 'text-xs px-2.5 py-1' : 'text-sm px-3 py-1.5';
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium whitespace-nowrap ${sizeClass} ${meta.badge}`}
    >
      {showIcon && (
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          <i className={`${meta.icon} text-[0.9em]`}></i>
        </span>
      )}
      {meta.label}
    </span>
  );
}